export const SharedFormMessages = {
  error: {
    max: {
      id: 'common.Form.Error.Max',
      defaultMessage: 'maximum value: {max}',
    },
    maxLength: {
      id: 'common.Form.Error.MaxLength',
      defaultMessage: 'maximum length: {maxLength}',
    },
    min: {
      id: 'common.Form.Error.Min',
      defaultMessage: 'minimum value: {min}',
    },
    minLength: {
      id: 'common.Form.Error.MinLength',
      defaultMessage: 'minimum length: {minLength}',
    },
    required: {
      id: 'common.Form.Error.Required',
      defaultMessage: 'Required',
    },
    email: {
      id: 'common.Form.Error.Email',
      defaultMessage: 'Email address is not in correct format',
    },
    equalTo: {
      id: 'common.Form.Error.EqualTo',
      defaultMessage: 'Passwords do not match.',
    },
  },
  date: {
    dd: {
      id: 'common.Form.Date.DD',
      defaultMessage: 'DD',
    },
    mm: {
      id: 'common.Form.Date.MM',
      defaultMessage: 'MM',
    },
    yyyy: {
      id: 'common.Form.Date.YYYY',
      defaultMessage: 'YYYY',
    },
  },
};
